<template>
  <div id="view">
    <historyTag :historyArr="historyArr"></historyTag>

    <div id="mainBox">
      <div class="bannerList" v-show="pageShow == 'index'">
        <div class="topBox flex">
          <ul class="flex">
            <li class="flex">
              <div style="width: 220px">
                <el-input v-model="searchName" placeholder="规格名称" clearable></el-input>
              </div>
            </li>
            <li class="flex" style="margin-left: 12px">
              <el-select v-model="statusFilter" placeholder="状态" clearable style="width: 140px">
                <el-option label="启用" :value="1"></el-option>
                <el-option label="停用" :value="0"></el-option>
              </el-select>
            </li>
            <li class="flex" style="margin-left: 12px">
              <el-button type="success" size="small" @click="searchFn">搜索</el-button>
            </li>
            <li class="flex" style="margin-left: 12px">
              <el-button type="primary" size="small" @click="openAdd">新增</el-button>
            </li>
          </ul>
        </div>

        <el-table border :data="tableData" style="width: 100%; margin-top: 10px">
          <el-table-column prop="name" align="center" label="规格名称" min-width="160"></el-table-column>
          <el-table-column prop="sort" align="center" label="排序" width="90"></el-table-column>
          <el-table-column prop="status" align="center" label="状态" width="90">
            <template slot-scope="scope">
              <span>{{ scope.row.status == 1 ? "启用" : "停用" }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" min-width="360">
            <template slot-scope="scope">
              <el-button type="info" size="small" @click="viewBrandsFn(scope.row)">查看关联品牌</el-button>
              <el-button type="warning" size="small" @click="quickConfigFn(scope.row)">一键配置</el-button>
              <el-button type="primary" size="small" @click="linkBrandFn(scope.row)">关联品牌</el-button>
              <el-button type="success" size="small" @click="openEdit(scope.row)">编辑</el-button>
              <el-button type="danger" size="small" @click="removeSpecFn(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="page_box">
          <el-pagination
            @current-change="changePage"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="tableTotal"
          ></el-pagination>
        </div>
      </div>

      <!-- 关联品牌弹窗（规格→品牌） -->
      <div class="excellent_box" v-if="linkBrandShow">
        <div class="excellent_main">
          <div class="excellent_top">
            关联品牌（{{ currentSpecName }}）
            <i class="el-icon-close" @click.stop="closeLinkBrandFn"></i>
          </div>

          <div class="excellent_content">
            <div class="excellent_li flex">
              <span>选择品牌：</span>
              <div style="width: 290px">
                <el-select v-model="selectedBrandId" filterable placeholder="请选择品牌" style="width: 100%">
                  <el-option
                    v-for="(item, index) in brandData"
                    :value="item.id"
                    :key="index"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </div>
            </div>

            <div class="excellent_btn flex">
              <el-button type="success" size="small" @click.stop="confirmLinkBrandFn">提交</el-button>
              <el-button type="info" size="small" @click.stop="closeLinkBrandFn">取消</el-button>
            </div>
          </div>
        </div>
      </div>

      <!-- 查看关联品牌弹窗 -->
      <div class="excellent_box" v-if="viewBrandsShow">
        <div class="excellent_main" style="height: 420px; width: 640px;">
          <div class="excellent_top">
            关联品牌列表（{{ currentSpecName }}）
            <i class="el-icon-close" @click.stop="closeViewBrandsFn"></i>
          </div>

          <div class="excellent_content" style="max-height: 340px; overflow-y: auto;">
            <el-table border :data="linkedBrandsList" style="width: 100%" v-if="linkedBrandsList.length > 0">
              <el-table-column prop="brandName" align="center" label="品牌名称"></el-table-column>
              <el-table-column align="center" label="操作" width="100">
                <template slot-scope="scope">
                  <el-button type="danger" size="small" @click="delLinkedBrandFn(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div v-else style="text-align: center; padding: 20px; color: #999;">暂无关联品牌</div>
          </div>
        </div>
      </div>

      <!-- 一键配置弹窗（规格→多品牌批量关联/删除） -->
      <div class="excellent_box" v-if="quickConfigShow">
        <div class="excellent_main quick-config-main">
          <div class="excellent_top">
            一键配置关联品牌（{{ currentSpecName }}）
            <i class="el-icon-close" @click.stop="closeQuickConfigFn"></i>
          </div>

          <div class="excellent_content">
            <div style="margin: 6px 0 10px; color: #666;">
              左侧为全部品牌，右侧为已关联品牌；调整后点击“保存”将批量新增/删除关联。
            </div>
            <el-transfer
              v-model="quickConfigSelected"
              filterable
              :titles="['全部品牌', '已关联']"
              :data="quickConfigTransferData"
              :props="{ key: 'key', label: 'label' }"
              :filter-placeholder="'搜索品牌'"
              :button-texts="['移除', '关联']"
              :disabled="quickConfigLoading"
            ></el-transfer>

            <div class="excellent_btn flex" style="margin-top: 14px;">
              <el-button type="success" size="small" :loading="quickConfigLoading" @click.stop="confirmQuickConfigFn">保存</el-button>
              <el-button type="info" size="small" :disabled="quickConfigLoading" @click.stop="closeQuickConfigFn">取消</el-button>
            </div>
          </div>
        </div>
      </div>

      <!-- 编辑弹窗（规格） -->
      <div class="excellent_box" v-if="editShow">
        <div class="excellent_main" style="height: 320px;">
          <div class="excellent_top">
            {{ editForm.id ? "编辑规格" : "新增规格" }}
            <i class="el-icon-close" @click.stop="closeEditFn"></i>
          </div>

          <div class="excellent_content">
            <div class="excellent_li flex">
              <span>规格名称：</span>
              <div style="width: 290px">
                <el-input v-model="editForm.name" placeholder="如 50ml"></el-input>
              </div>
            </div>
            <div class="excellent_li flex">
              <span>排序：</span>
              <div style="width: 290px">
                <el-input-number v-model="editForm.sort" :min="0" :max="9999" style="width: 100%"></el-input-number>
              </div>
            </div>
            <div class="excellent_li flex">
              <span>状态：</span>
              <div style="width: 290px">
                <el-radio-group v-model="editForm.status">
                  <el-radio :label="1">启用</el-radio>
                  <el-radio :label="0">停用</el-radio>
                </el-radio-group>
              </div>
            </div>

            <div class="excellent_btn flex">
              <el-button type="success" size="small" @click.stop="confirmEditFn">提交</el-button>
              <el-button type="info" size="small" @click.stop="closeEditFn">取消</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      historyArr: ["批号查询管理", "规格管理"],
      pageShow: "index",

      // 列表搜索
      searchName: "",
      statusFilter: null,
      currentPage: 1,
      pageSize: 10,
      tableTotal: 0,
      tableData: [],

      // 品牌列表（用于关联/展示名称）
      brandData: [],
      brandNameMap: {},

      // 关联品牌弹窗
      linkBrandShow: false,
      selectedBrandId: "",
      currentSpecId: null,
      currentSpecName: "",

      // 查看关联品牌弹窗
      viewBrandsShow: false,
      linkedBrandsList: [],

      // 一键配置弹窗
      quickConfigShow: false,
      quickConfigLoading: false,
      quickConfigTransferData: [],
      quickConfigSelected: [],
      quickConfigOriginMap: {},

      // 编辑弹窗
      editShow: false,
      editForm: {
        id: null,
        name: "",
        sort: 0,
        status: 1,
      },
    };
  },
  mounted() {
    this.selBrandFn();
    this.selListFn(1);
  },
  methods: {
    changePage(page) {
      this.selListFn(page);
    },
    searchFn() {
      this.currentPage = 1;
      this.selListFn(1);
    },
    selListFn(page) {
      if (page) this.currentPage = page;
      var obj = { page: this.currentPage || 1, size: this.pageSize };
      if (this.searchName) obj.name = this.searchName.trim();
      if (this.statusFilter !== null && this.statusFilter !== "") obj.status = this.statusFilter;
      this.$https(this.$api.api.specOptionPage, obj, "GET").then((res) => {
        if (res.data && res.data.code == 200) {
          this.tableData = res.data.data || [];
          this.tableTotal = res.data.size || 0;
        } else {
          this.tableData = [];
          this.tableTotal = 0;
          this.$message.error((res.data && res.data.msg) || "查询失败");
        }
      });
    },

    selBrandFn() {
      var obj = { page: 1, size: 1000 };
      this.$https(this.$api.api.selBrand, obj, "POST").then((res) => {
        if (res.data && res.data.code == 200) {
          this.brandData = res.data.data || [];
          var m = {};
          this.brandData.forEach((b) => {
            if (b && b.id != null) m[String(b.id)] = b.name || "";
          });
          this.brandNameMap = m;
        }
      });
    },

    // 规格新增/编辑
    openAdd() {
      this.editForm = { id: null, name: "", sort: 0, status: 1 };
      this.editShow = true;
    },
    openEdit(row) {
      this.editForm = {
        id: row.id,
        name: row.name || "",
        sort: row.sort != null ? row.sort : 0,
        status: row.status != null ? row.status : 1,
      };
      this.editShow = true;
    },
    closeEditFn() {
      this.editShow = false;
      this.editForm = { id: null, name: "", sort: 0, status: 1 };
    },
    confirmEditFn() {
      if (!this.editForm.name) {
        this.$message.error("请输入规格名称");
        return;
      }
      var api = this.editForm.id ? this.$api.api.specOptionUpdate : this.$api.api.specOptionSave;
      var payload = {
        id: this.editForm.id,
        name: this.editForm.name,
        sort: this.editForm.sort,
        status: this.editForm.status,
      };
      this.$https(api, payload, "POST").then((res) => {
        if (res.data && res.data.code == 200) {
          this.$message.success(res.data.msg || "操作成功");
          this.closeEditFn();
          this.selListFn(this.currentPage);
        } else {
          this.$message.error((res.data && res.data.msg) || "操作失败");
        }
      });
    },
    removeSpecFn(row) {
      if (!row || !row.id) return;
      this.$confirm("确认删除该规格？", "提示", { type: "warning" })
        .then(() => {
          var url = this.$api.api.specOptionRemove + row.id;
          this.$https(url, {}, "POST").then((res) => {
            if (res.data && res.data.code == 200) {
              this.$message.success("删除成功");
              this.selListFn(this.currentPage);
            } else {
              this.$message.error((res.data && res.data.msg) || "删除失败");
            }
          });
        })
        .catch(() => {});
    },

    // 规格→品牌 关联
    linkBrandFn(specRow) {
      this.currentSpecId = specRow && specRow.id;
      this.currentSpecName = (specRow && specRow.name) || "";
      this.selectedBrandId = "";
      this.linkBrandShow = true;
    },
    closeLinkBrandFn() {
      this.linkBrandShow = false;
      this.selectedBrandId = "";
      this.currentSpecId = null;
      this.currentSpecName = "";
    },
    confirmLinkBrandFn() {
      if (!this.currentSpecId) {
        this.$message.error("规格ID不能为空");
        return;
      }
      if (!this.selectedBrandId) {
        this.$message.error("请选择品牌");
        return;
      }
      // 统一走批量接口（即使只选 1 个），可自动去重
      var payload = { specOptionId: this.currentSpecId, brandIds: [Number(this.selectedBrandId)], isDefault: 0, sort: 0 };
      this.$https(this.$api.api.brandSpecAddBatch, payload, "POST").then((res) => {
        if (res.data && res.data.code == 200) {
          this.$message.success(res.data.msg || "关联成功");
          this.closeLinkBrandFn();
        } else {
          this.$message.error((res.data && res.data.msg) || "关联失败");
        }
      });
    },

    viewBrandsFn(specRow) {
      this.currentSpecId = specRow && specRow.id;
      this.currentSpecName = (specRow && specRow.name) || "";
      this.linkedBrandsList = [];
      this.viewBrandsShow = true;
      this.getBrandsBySpecId(this.currentSpecId);
    },
    closeViewBrandsFn() {
      this.viewBrandsShow = false;
      this.linkedBrandsList = [];
      this.currentSpecId = null;
      this.currentSpecName = "";
    },

    // 一键配置：批量关联/删除
    quickConfigFn(specRow) {
      this.currentSpecId = specRow && specRow.id;
      this.currentSpecName = (specRow && specRow.name) || "";
      if (!this.currentSpecId) {
        this.$message.error("规格ID不能为空");
        return;
      }
      this.quickConfigShow = true;
      this.quickConfigLoading = true;
      this.quickConfigSelected = [];
      this.quickConfigOriginMap = {};

      // transfer 数据源：全部品牌（key 统一用字符串，避免类型导致选中异常）
      this.quickConfigTransferData = (this.brandData || [])
        .filter((b) => b && b.id != null)
        .map((b) => ({ key: String(b.id), label: b.name || String(b.id) }));

      this.$https(this.$api.api.brandSpecListJson, { specOptionId: this.currentSpecId }, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            var list = res.data.data || [];
            var m = {};
            var selected = [];
            list.forEach((x) => {
              if (!x || x.brandId == null) return;
              m[String(x.brandId)] = { id: x.id, brandId: x.brandId, isDefault: x.isDefault, sort: x.sort };
              selected.push(String(x.brandId));
            });
            this.quickConfigOriginMap = m;
            this.quickConfigSelected = selected;
          } else {
            this.quickConfigOriginMap = {};
            this.quickConfigSelected = [];
            this.$message.error((res.data && res.data.msg) || "查询失败");
          }
        })
        .finally(() => {
          this.quickConfigLoading = false;
        });
    },
    closeQuickConfigFn() {
      this.quickConfigShow = false;
      this.quickConfigLoading = false;
      this.quickConfigTransferData = [];
      this.quickConfigSelected = [];
      this.quickConfigOriginMap = {};
      this.currentSpecId = null;
      this.currentSpecName = "";
    },
    confirmQuickConfigFn() {
      if (!this.currentSpecId) {
        this.$message.error("规格ID不能为空");
        return;
      }
      this.quickConfigLoading = true;

      var originKeys = Object.keys(this.quickConfigOriginMap || {});
      var selectedKeys = (this.quickConfigSelected || []).map((x) => String(x));
      var toAdd = selectedKeys.filter((k) => originKeys.indexOf(k) === -1);
      var toRemove = originKeys.filter((k) => selectedKeys.indexOf(k) === -1);

      var addPromise = Promise.resolve({ data: { code: 200 } });
      if (toAdd.length > 0) {
        addPromise = this.$https(
          this.$api.api.brandSpecAddBatch,
          { specOptionId: this.currentSpecId, brandIds: toAdd.map((x) => Number(x)), isDefault: 0, sort: 0 },
          "POST"
        );
      }

      var removeIds = toRemove
        .map((k) => this.quickConfigOriginMap[k])
        .filter((row) => row && row.id)
        .map((row) => row.id);
      var removePromise = Promise.resolve({ data: { code: 200 } });
      if (removeIds.length > 0) {
        removePromise = this.$https(this.$api.api.brandSpecRemoveBatch, { ids: removeIds }, "POST");
      }

      Promise.all([addPromise, removePromise])
        .then((arr) => {
          var addRes = arr && arr[0];
          var rmRes = arr && arr[1];
          var okAdd = addRes && addRes.data && addRes.data.code == 200;
          var okRm = rmRes && rmRes.data && rmRes.data.code == 200;
          if (okAdd && okRm) {
            this.$message.success("保存成功（新增 " + toAdd.length + "，删除 " + toRemove.length + "）");
            this.closeQuickConfigFn();
          } else {
            this.$message.warning("保存可能未全部成功，请检查后重试");
          }
        })
        .catch(() => {
          this.$message.error("保存失败");
        })
        .finally(() => {
          this.quickConfigLoading = false;
        });
    },
    getBrandsBySpecId(specOptionId) {
      if (!specOptionId) return;
      // 后端 brandSpec/list 是 @ModelAttribute 方式，POST JSON 无法绑定；这里用 listJson 专门接收 JSON body
      this.$https(this.$api.api.brandSpecListJson, { specOptionId: specOptionId }, "POST").then((res) => {
        if (res.data && res.data.code == 200) {
          var list = res.data.data || [];
          this.linkedBrandsList = list.map((x) => ({
            id: x.id,
            brandId: x.brandId,
            brandName: this.brandNameMap[String(x.brandId)] || "",
            isDefault: x.isDefault,
            sort: x.sort,
          }));
        } else {
          this.linkedBrandsList = [];
          this.$message.error((res.data && res.data.msg) || "查询失败");
        }
      });
    },
    delLinkedBrandFn(row) {
      if (!row || !row.id) return;
      this.$confirm("确认删除该关联？", "提示", { type: "warning" })
        .then(() => {
          // 统一走批量删除接口（即使只删 1 条）
          this.$https(this.$api.api.brandSpecRemoveBatch, { ids: [row.id] }, "POST").then((res) => {
            if (res.data && res.data.code == 200) {
              this.$message.success("删除成功");
              this.getBrandsBySpecId(this.currentSpecId);
            } else {
              this.$message.error((res.data && res.data.msg) || "删除失败");
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="less">
#mainBox {
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
}
.topBox {
  width: 100%;
  margin-bottom: 10px;
  text-align: right;
  justify-content: space-between;
}
.page_box {
  margin-top: 16px;
  text-align: right;
}

.bannerList {
  width: 100%;
}

// 关联品牌弹窗（复用 brandLogic 的样式）
.excellent_box {
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  background: rgba(000, 000, 000, 0.5);

  .excellent_main {
    width: 450px;
    height: 250px;
    margin: auto;
    background: #fff;
    transform: translate(-50%, -50%);
    position: fixed;
    left: 50%;
    top: 50%;
    border-radius: 5px;
    overflow: hidden;

    .excellent_top {
      width: 96%;
      height: 40px;
      background: #eee;
      line-height: 40px;
      padding: 5px 2%;
      font-size: 15px;
      i {
        float: right;
        margin-top: 10px;
        font-size: 20px;
        cursor: pointer;
      }
    }

    .excellent_content {
      width: 100%;
      margin-top: 10px;
      padding: 0 15px;
      box-sizing: border-box;

      .excellent_li {
        margin-top: 25px;

        .el-select {
          width: 100%;
        }

        span {
          width: 120px;
          display: inline-block;
          flex-shrink: 0;
          text-align: right;
        }
      }

      .excellent_btn {
        justify-content: flex-end;
        margin: 25px 15px 0px 0px;
      }
    }
  }
}

.quick-config-main {
  width: 900px !important;
  height: 560px !important;
}
</style>




// WEBPACK FOOTER //
// src/pages/batchQuery/specConfig.vue